import { TransLink } from "components/trans/transLink";
import { useThemeSettings } from "hooks/queries/useThemeSettings.query";
import React, { useEffect, useState } from "react";
import "./cookieNotice.scss";
import parse from "html-react-parser";
import classNames from "classnames";
import Cookies from "js-cookie";
import Button from "blocks/button/button";

interface Props {}

const CookieNotice: React.FC<Props> = (props) => {
  const [doRender, setDoRender] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const options = useThemeSettings();
  const cnData = options.wp.themeGeneralSettings.cookieNotice;

  useEffect(() => {
    if (!Cookies.get("cn-accept")) {
      setDoRender(true);
    }
  }, []);

  useEffect(() => {
    !!doRender && setIsOpen(true);
  }, [doRender]);

  const handleClick = () => {
    Cookies.set("cn-accept", "true", { expires: 365 });
    setIsOpen(false);
  };

  if (!doRender) {
    return null;
  }

  // console.log(options);

  return (
    <div className={classNames("cookie-notice", { "is-open": isOpen })}>
      <div className="cookie-notice__inner">
        <div className="cookie-notice__text">
          {!!cnData.text && parse(cnData.text)}
        </div>
        <Button onClick={handleClick} label={cnData.buttonLabel} />
      </div>
    </div>
  );
};

export default CookieNotice;
